<template>
  <ConnectionSegment
    :title="$t('connection-manager.connections.crm.title')"
    :description="$t('connection-manager.connections.crm.description')"
  >
    <CrmWrapper
      v-for="connection in crmConnections"
      :key="connection.id"
      :provider="connection.provider"
    >
      <template
        #activator="{ props, isConnected, loading, connect, settings, disabled, disconnect }"
      >
        <Connection
          :is-new="connection.isNew"
          :active="isConnected"
          :disabled="disabled"
          :image="connection.image"
          :loading="loading"
          :dialogActivatorProps="props"
          :connectionButtonText="`connection-manager.crm.${connection.provider.toLowerCase()}.connect`"
          show-settings
          @connect="connect"
          @settings="settings"
          @disconnect="disconnect"
        />
      </template>
    </CrmWrapper>
  </ConnectionSegment>
</template>

<script lang="ts" setup>
import { computed } from 'vue'

import { useCrm } from '@/composables/useCrm'
import { CrmProvider } from '@/generated/graphql'

import Connection from './Connection.vue'
import ConnectionSegment from './ConnectionSegment.vue'
import CrmWrapper from './crmWrapper/index.vue'

const { providers } = useCrm()

const crmConnections = computed(() => {
  if (!providers.value.length) return []

  const imageMapper: Partial<Record<CrmProvider, string>> = {
    [CrmProvider.Flowfact]: '/img/flowfact.png',
    [CrmProvider.Propstack]: '/img/propstack.png',
    [CrmProvider.Onoffice]: '/img/onOffice-new.png',
    [CrmProvider.Casaone]: '/img/casaone.svg',
    [CrmProvider.Empro]: '/img/empro.png',
  }
  return providers.value.map((provider) => ({
    id: provider.value,
    image: imageMapper[provider.value] ?? '',
    provider: provider.value,
    isNew: false,
  }))
})
</script>
